module.exports = {
          srcSet: __webpack_public_path__ + "img/6be5f5d-2448.jpg"+" 2448w",
          images:[ {path: __webpack_public_path__ + "img/6be5f5d-2448.jpg",width: 2448,height: 3264}],
          src: __webpack_public_path__ + "img/6be5f5d-2448.jpg",
          toString:function(){return __webpack_public_path__ + "img/6be5f5d-2448.jpg"},
          
          width: 2448,
          height: 3264
        }